import type { USER_ROLE_WITHOUT_GUEST_AND_USER } from 'cpool-constants';

import useUserInfo from '~/hooks/useUserInfo.tsx';

type PermissionRole = USER_ROLE_WITHOUT_GUEST_AND_USER | `!${USER_ROLE_WITHOUT_GUEST_AND_USER}`;

type PropsRequiredRoles = {
    children: React.ReactNode;
    requiredRoles: USER_ROLE_WITHOUT_GUEST_AND_USER | ReadonlyArray<PermissionRole | ReadonlyArray<PermissionRole>>;
};

const matchesRole = (userRole: USER_ROLE_WITHOUT_GUEST_AND_USER, role: PermissionRole): boolean => {
    if (role.charAt(0) === '!') return userRole !== role.substring(1);
    return userRole === role;
};

const RequiredRoles: React.FC<PropsRequiredRoles> = ({ children, requiredRoles: wantedRoles }) => {
    const user = useUserInfo();
    const userRole = user?.role;

    if (!userRole) return null;

    const roles = Array.isArray(wantedRoles) ? wantedRoles : [wantedRoles];

    if (roles.length === 0) return children;

    const hasPermission = roles.some((role) => {
        if (Array.isArray(role)) return role.every((entry) => matchesRole(userRole, entry));
        return matchesRole(userRole, role);
    });

    if (!hasPermission) return null;

    return children;
};

export default RequiredRoles;
